import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const apiDocsTranslation = TranslationBlueprint.make({
  name: 'api-docs',
  params: {
    resource: createTranslationMessages({
      ref: apiDocsTranslationRef,
      full: false,
      messages: {
        'apiDefinitionCard.error.title': 'De API kon niet worden opgehaald',
        'apiDefinitionCard.rawButtonTitle': 'Ruwe weergave',
        'apiDefinitionDialog.closeButtonTitle': 'Sluit',
        'apiDefinitionDialog.tabsAriaLabel': 'Opties voor API-definitie',
        'apiDefinitionDialog.toggleButtonAriaLabel':
          'Open of sluit venster met API-definitie',
        'apiDefinitionDialog.rawButtonTitle': 'Ruwe weergave',
        'defaultApiExplorerPage.title': "API's",
        'defaultApiExplorerPage.subtitle': "API's van {{orgName}}",
        'defaultApiExplorerPage.pageTitleOverride': "API's",
        'defaultApiExplorerPage.createButtonTitle': 'Registreer bestaande API',
        'defaultApiExplorerPage.supportButtonTitle': "Al je API's",
        'consumedApisCard.title': "Afgenomen API's",
        'consumedApisCard.error.title': "De API's konden niet worden geladen",
        'consumedApisCard.emptyContent.title':
          "Deze {{entity}} neemt geen API's af.",
        'hasApisCard.title': "API's",
        'hasApisCard.error.title': "De API's konden niet worden geladen",
        'hasApisCard.emptyContent.title': "Deze {{entity}} bevat geen API's.",
        'providedApisCard.title': "Aangeboden API's",
        'providedApisCard.error.title': "De API's konden niet worden geladen",
        'providedApisCard.emptyContent.title':
          "Deze {{entity}} biedt geen API's aan.",
        'apiEntityColumns.typeTitle': 'Type',
        'apiEntityColumns.apiDefinitionTitle': 'API-definitie',
        'consumingComponentsCard.title': 'Afnemers',
        'consumingComponentsCard.error.title':
          'De componenten konden niet worden geladen',
        'consumingComponentsCard.emptyContent.title':
          'Geen enkel component neemt deze API af.',
        'providingComponentsCard.title': 'Aanbieders',
        'providingComponentsCard.error.title':
          'De componenten konden niet worden geladen',
        'providingComponentsCard.emptyContent.title':
          'Geen enkel component biedt deze API aan.',
        apisCardHelpLinkTitle: 'Lees hoe je dit wijzigt.',
      },
    }),
  },
});
